export default function convertMonthToNumeric(value) {
    let dummyStr = '',
        year = '';
    let returnDate = '';
    for (let i = 0; i < 3; i++) dummyStr += value[i];
    for (let i = 4; i < value.length; i++) year += value[i];
    returnDate += year;
    returnDate += '-';
    switch (dummyStr) {
        case 'Jan':
            returnDate += '01';
            break;
        case 'Feb':
            returnDate += '02';
            break;
        case 'Mar':
            returnDate += '03';
            break;
        case 'Apr':
            returnDate += '04';
            break;
        case 'May':
            returnDate += '05';
            break;
        case 'Jun':
            returnDate += '06';
            break;
        case 'Jul':
            returnDate += '07';
            break;
        case 'Aug':
            returnDate += '08';
            break;
        case 'Sep':
            returnDate += '09';
            break;
        case 'Oct':
            returnDate += '10';
            break;
        case 'Nov':
            returnDate += '11';
            break;
        case 'Dec':
            returnDate += '12';
            break;
        default:
            return '';
    }
    return returnDate;
}

export function dateFormatUtil() {
    var date = new Date();
    var aaaa = date.getFullYear();
    var gg = date.getDate();
    var mm = date.getMonth() + 1;

    if (gg < 10) gg = '0' + gg;

    if (mm < 10) mm = '0' + mm;

    var cur_day = aaaa + '-' + mm + '-' + gg;

    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();

    if (hours < 10) hours = '0' + hours;

    if (minutes < 10) minutes = '0' + minutes;

    if (seconds < 10) seconds = '0' + seconds;

    return cur_day + ' ' + hours + ':' + minutes + ':' + seconds;
}


export function getFormattedDateFromString(timestamp) {
    if(timestamp){
        var timestamp = timestamp * 1000;
        var date = new Date(timestamp)
        var time = new Date(new Date(date).toString());
		var timeString = time.toLocaleString('en-US', { hour: "2-digit",minute: "2-digit",second: "2-digit", })
	
		const tempDate = new Date(date).toString().split(' ');
		const formattedDate = tempDate['2']+' '+tempDate['1']+', '+tempDate['3']+' - '+timeString;
		return formattedDate
        
		}else{
		return '';
		}
}
export function getFormattedDateTime(date) {
		if(date){
		var time = new Date(new Date(date).toString());
		var timeString = time.toLocaleString('en-US', { hour: "2-digit",minute: "2-digit",second: "2-digit", })
	
		const tempDate = new Date(date).toString().split(' ');
		const formattedDate = tempDate['2']+' '+tempDate['1']+', '+tempDate['3']+' - '+timeString;
		return formattedDate
		}else{
		return '';
		}
	}

export function getFormattedDate(date) {
        if(date){
		const tempDate = new Date(date).toString().split(' ');
		const formattedDate = tempDate['2']+' '+tempDate['1']+', '+tempDate['3'];
		return formattedDate
		}else{
		return '';
		}
	}
	
